import Link from 'next/link';
import styled from 'styled-components';

export const Container = styled.div``;

export const PropertyRow = styled(Link)`
  display: flex;
  margin-bottom: 15px;
  
  p {
    color: ${({ theme }) => theme.textDark});
    font-size: 14px;
  }

  img {
    height: 84px;
    margin-right: 10px;
  }

  &:hover {
    p {
      text-decoration: underline;
    }
  }
`;
